import React, { Component } from 'react';
import { findDOMNode } from 'react-dom';
import Promise from 'bluebird';

// Components
import FullPageLayout from '../../components/FullPageLayout';
import { ResponsiveImage } from 'dabbl-react-components';
import LoadingSpinner from '../../components/LoadingSpinner';
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  Input
} from 'reactstrap';

// Images
import {RETAILER_NAME, BACK_CARD_IMAGE} from "../../retailerValues";

class LoginPage extends Component {

  state = {
    isLoading: false
  }

  // Bind Functions
  inputEnterListener = this.inputEnterListener.bind(this);

  componentDidMount() {
    // scroll to top of page
    window.scrollTo(0,0);

    // Removing Loading Screen
    this.props.setLoading(false);

    // this.seenTutorial = window.localStorage.getItem("adjoy_seenTutorial");

    // Add 'Enter' key listener for input
    const input = findDOMNode(this.input);
    input.addEventListener('keydown', this.inputEnterListener, false);
  }

  componentWillUnmount() {
    const input = findDOMNode(this.input);
    input.removeEventListener('keydown', this.inputEnterListener, false);
  }

  isUserAuthenticated() {
    const { authToken, userId, cardNumber } = this.props;

    if (authToken === null || authToken === undefined
      || userId === null   || userId === undefined
      || cardNumber === null || cardNumber === undefined )
      return false;

    return true;
  }

  inputEnterListener(e) {
    if (e.which === 13) { // enter key
      this.authenticateCard(e);
    }
  }

  authenticateCard(e){
    e.preventDefault();

    const {
      createNewUserOrSignIn,
      invalidateAllAuth,
      history
    } = this.props;

    const cardNum = findDOMNode(this.input).value;

    if (cardNum.length === 11 && !isNaN(Number(cardNum))) {
      return Promise.resolve()
      .then(() => this.setState({ isLoading: true }))
      .then(() => invalidateAllAuth()) // remove previous info
      .then(() => createNewUserOrSignIn(cardNum))
      .then((isNewUser) => { // redirect
        if (isNewUser !== true)
          history.push('/app/campaigns');
        else history.push('/app/tutorial');
      })
      .catch(err => {
        this.setState({ isLoading: false });

        console.error('Failed to authenticate user.');
        console.error(err);
      });
    }

    return false;
  }

  render(){
    const { isLoading } = this.state;

    return (
      <FullPageLayout className="Login">
        <div>
          <Container>
            <Row>
              <Col xs={12} md={{size: 8, offset: 2}} lg={{size: 6, offset: 3}}>
                <Card className="Login_card">
                  {/* Loading Overlay */}
                  {isLoading && (
                    <div className="Login_loadingOverlay">
                      <LoadingSpinner className="Login_loadingSpinner" />
                    </div>
                  )}

                  {/* Card Content */}
                  <CardBody>
                    <CardTitle>Enter card here:</CardTitle>
                    <Input
                      ref={n => (this.input = n)}
                      className="Login_input"
                      type="input"
                      minLength={11}
                      maxLength={11}
                    />
                    <button
                      type="button"
                      className="btn btn-success pull-right"
                      onClick={(e) => this.authenticateCard(e)}
                    >
                      Submit
                    </button>
                  </CardBody>

                  <CardBody style={{border: '1px solid silver', height: '100%'}}>
                    <ul>
                      <li>Enter the first 11 digits of your Price Plus Club Card.</li>
                      <li>Do not enter the last digit.</li>
                    </ul>
                    <ResponsiveImage
                      src={BACK_CARD_IMAGE}
                      alt={`${RETAILER_NAME} card barcode`}
                    />
                  </CardBody>

                  <CardBody style={{border: '1px solid silver', marginTop: '15px'}}>
                    Note: this page is for demo purposes only.
                    It will be replaced with single sign-on (SSO).
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </FullPageLayout>
    );
  }
}

export default LoginPage;



// WEBPACK FOOTER //
// ./src/pages/Login/Login.js